import Hero from '../components/Hero'
import HowItWorks from '../components/HowItWorks'
import WhyChooseUs from '../components/WhyChooseUs'
import PricingPreview from '../components/PricingPreview'
import Testimonials from '../components/Testimonials'
import FAQ from '../components/FAQ'
import FinalCTA from '../components/FinalCTA'

const Home = () => {
  return (
    <main className="pt-20">
      <Hero />
      <HowItWorks />
      <WhyChooseUs />
      <PricingPreview />
      <Testimonials />
      <FAQ />
      <FinalCTA />
    </main>
  )
}

export default Home
